import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createAwsDxgwIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M33.4395 12.3487L31.5304 15.6598L30.7063 15.1838L35.484 19.9615L30.5249 24.9194L31.5304 24.3402L33.4395 27.65L19.8968 35.4691L6.35298 27.65L6.98934 26.5488L8.26207 24.3402L8.92329 24.7218L4.51846 20.3169L5.42081 19.4146L5.36861 19.3636H5.47177L9.93128 14.9054L10.4247 14.4107L9.36576 15.0234L8.26207 15.6598L7.62695 14.5561L6.35422 12.3487L19.8968 4.53088L33.4395 12.3487Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.8967 6L8.09151 12.8151L8.729 13.921L19.2579 7.84161V19.3609H9.07996L11.7326 16.7083L10.831 15.806L6.31818 20.3175L10.831 24.829L11.7326 23.9273L8.44184 20.6365H19.2579V32.1578L8.729 26.079L8.09151 27.1843L19.8967 34L31.7013 27.1843L31.0638 26.079L20.5348 32.1578V20.6365H31.2042L28.2707 23.5712L29.173 24.4729L33.6845 19.9614L29.173 15.4493L28.2707 16.3516L31.2788 19.3609H20.5348V7.84161L31.0638 13.921L31.7013 12.8151L19.8967 6Z" fill="#8C4FFF"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const awsDxgwIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAwsDxgwIcon,
);
